import TmdbFooter from './TmdbFooter'
import { IconBook, IconClapper } from './icons'

export default function SettingsScreen({ settings, onUpdateSettings, onHowToPlay, onTerms, onPrivacy, onSupport, onBack }) {
  return (
    <div className="settings-screen">
      <div className="screen-content">
        <h2 className="settings-screen__title">Settings</h2>

        <section className="settings-section">
          <h3 className="settings-section__title">About</h3>
          <p className="settings-about">
            Action! is a movie connection game — link two actors through shared films in as few hops as possible. The fewer hops, the better.
          </p>
          <p className="settings-about" style={{ marginTop: 12 }}>
            Tap any movie poster throughout the app to explore its cast and start making connections. For a full walkthrough, tap How to Play in the menu.
          </p>
          <p className="settings-about" style={{ marginTop: 12 }}>
            Questions, feedback, or just want to say hi?<br />
            <a href="mailto:support@actionthemoviegame.com">support@actionthemoviegame.com</a>
          </p>
        </section>

        <section className="settings-section">
          <h3 className="settings-section__title">Gameplay</h3>

          <label className="settings-toggle">
            <div>
              <span className="settings-toggle__label">Highlight destination actor</span>
              <span className="settings-toggle__hint">Show a gold ring on the goal actor in cast grids</span>
            </div>
            <input
              type="checkbox"
              checked={!!settings.destinationHighlight}
              onChange={(e) => onUpdateSettings({ destinationHighlight: e.target.checked })}
            />
          </label>
        </section>

        <section className="settings-section">
          <h3 className="settings-section__title">Help</h3>
          <button
            type="button"
            className="settings-help-row"
            onClick={onHowToPlay}
          >
            <span className="settings-help-row__label">How to Play <IconBook size={15} style={{ verticalAlign: 'middle' }} /></span>
            <span className="settings-help-row__chevron" aria-hidden="true">›</span>
          </button>
        </section>

        <section className="settings-section">
          <h3 className="settings-section__title">Legal &amp; Support</h3>
          <button type="button" className="settings-help-row" onClick={onSupport}>
            <span className="settings-help-row__label">Support &amp; FAQ <IconClapper size={15} style={{ verticalAlign: 'middle' }} /></span>
            <span className="settings-help-row__chevron" aria-hidden="true">›</span>
          </button>
          <button type="button" className="settings-help-row" onClick={onTerms}>
            <span className="settings-help-row__label">Terms of Use</span>
            <span className="settings-help-row__chevron" aria-hidden="true">›</span>
          </button>
          <button type="button" className="settings-help-row" onClick={onPrivacy}>
            <span className="settings-help-row__label">Privacy Policy</span>
            <span className="settings-help-row__chevron" aria-hidden="true">›</span>
          </button>
        </section>

        <TmdbFooter />
      </div>
    </div>
  )
}
